import React from "react";
import { FormControl } from "react-bootstrap";
import ajax from "../../lib/ajax.js";
import context from "../../lib/context.js";
import ReactDOM from 'react-dom';

export default class State extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            states: []
        };

        this.loadStates = this.loadStates.bind(this);
        this.onChange = this.onChange.bind(this);
    }    

    componentDidMount() {
        this.loadStates();
    }

    loadStates() {
        let self = this;
        ajax.api().get(`get-states`)
            .then(function (res) {
                self.setState({ states: res.data });
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    onChange(event) {
        if (this.props.onChange)
            this.props.onChange(event.target.value, event.target.options[event.target.selectedIndex].text, this.props.dataKey);
    }

    render() {
        var states = [];
        var allText = 'All';
        
        if (this.props.allText !== undefined)
            allText = this.props.allText;

        states.push(<option key="All" value="" selected="true">{allText}</option>);
        
        if (this.props.country != '') {
            this.state.states.filter(x => x.country == this.props.country).map(function (item, i) {
                states.push(<option key={item.code} value={item.code}>{item.description}</option>)
            }, this);
        }

        return (   
            <div className="ap-report-control-dropdown">       
                <FormControl
                    id={this.props.id + '-select'}
                    componentClass="select"
                    value={this.props.value}
                    onChange={this.onChange}
                    inputRef={el => this.inputEl = el}
                    className={this.props.className}
                    readOnly={this.props.readOnly}>
                    {states}
                </FormControl>
            </div>
        );
    }
}